module.exports = __webpack_public_path__ + "img/screen-icon.ce4a7f47.svg";